var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.9,31.8l-0.1-0.2c-0.7-1.3-2.1-4.3-5.5-5.8c1.1-1.2,1.8-2.9,1.8-4.7c0-3.7-2.9-6.8-6.5-6.8s-6.5,3-6.5,6.8 c0,1.8,0.7,3.5,1.8,4.7c-3.3,1.3-4.7,4.1-5.5,6.6l-1.1,3.1l2.8,1l1.1-3.1C12.4,30,14,28,18.9,28c4.8,0,6.4,3.3,7.2,5l1.6,3.7 l2.8-1.2L28.9,31.8z M18.6,17.3c1.9,0,3.5,1.7,3.5,3.8s-1.6,3.8-3.5,3.8c-1.9,0-3.5-1.7-3.5-3.8S16.7,17.3,18.6,17.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuUser);
export default __webpack_public_path__ + "static/media/icon-menu-user.0983cc0ba3b25fa413845fa6bae64706.svg";
export { ForwardRef as ReactComponent };